import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Label,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import Shimmer from "react-shimmer-effect";
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import UpdateBloc from './Blocs/UpdateBloc'
import { accessRole } from "../../../../helpers/access_role"
import CustomSelect from '../../../../helpers/ui/CustomSelect';
import moment from 'moment';

const createYearOption = (startYear = 2000) => {
  var currentYear = new Date().getFullYear(), years = [];
    startYear = startYear || 1980;  
    while ( startYear <= currentYear ) {
        var newObj = {};
        var year = startYear++;
        newObj["label"] = year;
        newObj["value"] = year;
        years.push(newObj);
    }   
    return years;
}

class IndexView extends Component {

    updateBloc = new UpdateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {
                uuid:"",
                nip: "",
                nama: "",
                unit_kerja: "",
                jabatan: "",
                tmt_jabatan: "",
                golongan: "",
                tgl_lahir: "",
                jenis_kelamin: "",
            },
            educationOptions: [],
            yearOptions: createYearOption(new Date().getFullYear() - 100),
        }
    }

    dateParse = (input) =>{
      let res = "";
      if (input != "" && input != null){
        res = moment(input).format('DD/MM/YYYY')
      }
      return res;
    }

    reformatOptions = (raw, label, value) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = data[label];
          newObj["value"] = data[value];
      
          return newObj;
        });
    };

    submitData = async () => {
      const formData = generateFormData(this.state.dataForm, ['file_sk', 'file_ijazah', 'file_penyetaraan', 'file_akre']) // Jika nama field fileinputnya adalah 'File', maka parameter kedua boleh dikosongkan. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
      await this.updateBloc.fetchUpdate(formData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              ...values,
              education_background_employee_uuid: this.state.dataForm.education_background_employee_uuid
            },
            confirm: true
        })
    }

    onChangeTypeSelected = (type) => {
        this.setState({
            typeSelected: type.value,
        });
    }   
  
    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {

        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.updateBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        let employee = response.employee

                        // load to form
                        this.setState({
                            dataForm: {
                                nip: employee.employee_nip,
                                nama: employee.employee_full_name,
                                unit_kerja: employee.employee_current_work_unit_name,
                                jabatan: employee.employee_current_position_name,
                                tmt_jabatan: employee.employee_current_tmt_position,
                                golongan: employee.employee_current_rank_group_room,
                                tgl_lahir: employee.employee_date_of_birth,
                                jenis_kelamin: employee.employee_gender_name,

                                uuid : response.education_background_uuid,
                                education_background_certificate_date: response.education_background_certificate_date,
                                education_background_certificate_number: response.education_background_certificate_number,
                                education_background_education_name: response.education_background_education_name,
                                education_background_education_uuid: response.education_background_education_uuid,
                                education_background_employee_uuid: response.education_background_employee_uuid,
                                education_background_end_title: response.education_background_end_title,
                                education_background_front_title: response.education_background_front_title,
                                education_background_graduation_year: response.education_background_graduation_year,
                                education_background_school_address: response.education_background_school_address,
                                education_background_school_major: response.education_background_school_major,
                                education_background_school_name: response.education_background_school_name,
                                education_background_title_sk_date: response.education_background_title_sk_date,
                                education_background_title_sk_document_uuid: response.education_background_title_sk_document_uuid,
                                education_background_title_sk_number: response.education_background_title_sk_number,
                                education_background_title_text: response.education_background_title_text,

                                document_ijazah: response.document_ijazah,
                                document_akreditasi: response.document_akreditasi,
                                document_penyetaraan: response.document_penyetaraan,
                                document_sk: response.document_sk,
                            }
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.updateBloc.educationChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response
                      this.setState({
                          educationOptions: this.reformatOptions(
                            response.result,
                            "education_name",
                            "education_uuid"
                          )
                      })
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
        })  

        const search = window.location.search
        const queryParams = new URLSearchParams(search)
        
        this.updateBloc.fetchDetail({ uuid: queryParams.get('uuid') })
        this.updateBloc.fetchEducation()
    }

    componentWillUnmount(){
        this.updateBloc.updateChannel.unsubscribe()
        this.updateBloc.educationChannel.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card className="">
                                <CardBody>
                                    <CardTitle>Edit Pencantuman Gelar</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />

                                    
                                        <AvForm
                                            className="needs-validation"
                                            onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                        >

                                        <AvField
                                                name="uuid"
                                                type="hidden"
                                                id="uuid"
                                                value={this.state.dataForm.uuid}
                                        />

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            NIP 
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    placeholder=""
                                                    name="nip"
                                                    id="nip"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.nip}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama 
                                            </label>
                                            <Col md="5">
                                                 <AvField
                                                    placeholder=""
                                                    name="nama"
                                                    id="nama"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.nama}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Unit Kerja
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="unit_kerja"
                                                    id="unit_kerja"
                                                    readonly="readonly"
                                                    type="textarea"
                                                    className="form-control"
                                                    value={this.state.dataForm.unit_kerja}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jabatan 
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="jabatan"
                                                    id="jabatan"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.jabatan}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            TMT Jabatan 
                                            </label>
                                            <Col md="2">
                                                 <AvField
                                                    placeholder=""
                                                    name="tmt_jabatan"
                                                    id="tmt_jabatan"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.dateParse(this.state.dataForm.tmt_jabatan)}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Golongan 
                                            </label>
                                            <Col md="1">
                                                <AvField
                                                    placeholder=""
                                                    name="golongan"
                                                    id="golongan"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.golongan}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Lahir 
                                            </label>
                                            <Col md="2">
                                                <AvField
                                                    placeholder=""
                                                    name="tgl_lahir"
                                                    id="tgl_lahir"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.dateParse(this.state.dataForm.tgl_lahir)}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jenis Kelamin 
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    placeholder=""
                                                    name="jenis_kelamin"
                                                    id="jenis_kelamin"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.jenis_kelamin}
                                                />
                                            </Col>
                                        </Row>

                                        <hr />

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jenjang <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                <CustomSelect 
                                                    name="education_background_education_uuid"
                                                    errorMessage="Pilih Jenjang"
                                                    options={this.state.educationOptions} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Jenjang"
                                                    defaultValue={this.state.dataForm.education_background_education_uuid}
                                                />
                                            </Col>
                                        </Row>     

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama Universitas / Perguruan Tinggi <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                 <AvField
                                                    name="education_background_school_name"
                                                    id="education_background_school_name"
                                                    placeholder="Nama Universitas / Perguruan Tinggi"
                                                    type="text"
                                                    errorMessage="Masukan Nama Universitas / Perguruan Tinggi"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.dataForm.education_background_school_name}
                                                />
                                            </Col>
                                        </Row> 

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jurusan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                 <AvField
                                                    name="education_background_school_major"
                                                    id="education_background_school_major"
                                                    placeholder="Jurusan"
                                                    type="text"
                                                    errorMessage="Masukan Jurusan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.dataForm.education_background_school_major}
                                                />
                                            </Col>
                                        </Row>   

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Alamat Universitas / Perguruan Tinggi <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                 <AvField
                                                    name="education_background_school_address"
                                                    id="education_background_school_address"
                                                    placeholder="Alamat Universitas / Perguruan Tinggi"
                                                    type="text"
                                                    errorMessage="Masukan Alamat Universitas / Perguruan Tinggi"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.dataForm.education_background_school_address}
                                                />
                                            </Col>
                                        </Row>  

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nomor Ijazah <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                 <AvField
                                                    name="education_background_certificate_number"
                                                    id="education_background_certificate_number"
                                                    placeholder="Nomor Ijazah"
                                                    type="text"
                                                    errorMessage="Masukan Nomor Ijazah"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.dataForm.education_background_certificate_number}
                                                />
                                            </Col>
                                        </Row>  

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Ijazah <span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                                 <AvField
                                                    name="education_background_certificate_date"
                                                    id="education_background_certificate_date"
                                                    placeholder="Tanggal Ijazah"
                                                    type="date"
                                                    errorMessage="Masukan Tanggal Ijazah"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.dataForm.education_background_certificate_date}
                                                />
                                            </Col>
                                        </Row>        

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tahun Lulus <span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                                <CustomSelect 
                                                    name="education_background_graduation_year"
                                                    errorMessage="Pilih Tahun Lulus"
                                                    options={this.state.yearOptions} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Tahun Lulus"
                                                    defaultValue={this.state.dataForm.education_background_graduation_year}
                                                />
                                            </Col>
                                        </Row>       

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama Gelar Lengkap
                                            {/* <span className="text-danger">*</span> */}
                                            </label>
                                            <Col md="4">
                                                 <AvField
                                                    name="education_background_title_text"
                                                    id="education_background_title_text"
                                                    placeholder="Nama Gelar Lengkap"
                                                    type="text"
                                                    errorMessage="Masukan Nama Gelar Lengkap"
                                                    className="form-control"
                                                    validate={{ required: { value: false } }}
                                                    value={this.state.dataForm.education_background_title_text}
                                                />
                                            </Col>
                                        </Row>  

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Gelar Depan 
                                            {/* <span className="text-danger">*</span> */}
                                            </label>
                                            <Col md="2">
                                                 <AvField
                                                    name="education_background_front_title"
                                                    id="education_background_front_title"
                                                    placeholder="Gelar Depan"
                                                    type="text"
                                                    errorMessage="Masukan Gelar Depan"
                                                    className="form-control"
                                                    validate={{ required: { value: false } }}
                                                    value={this.state.dataForm.education_background_front_title}
                                                />
                                            </Col>
                                        </Row>    

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Gelar Belakang 
                                            {/* <span className="text-danger">*</span> */}
                                            </label>
                                            <Col md="2">
                                                 <AvField
                                                    name="education_background_end_title"
                                                    id="education_background_end_title"
                                                    placeholder="Gelar Belakang"
                                                    type="text"
                                                    errorMessage="Masukan Gelar Belakang"
                                                    className="form-control"
                                                    validate={{ required: { value: false } }}
                                                    value={this.state.dataForm.education_background_end_title}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">Upload File Ijazah & Transkrip Nilai</Label>
                                            <Col md="6">
                                                <FileInput
                                                    name="file_ijazah"
                                                    col="6"
                                                />
                                                <div className="mt-2">
                                                    {
                                                        this.state.dataForm ?
                                                            <>
                                                                {this.state.dataForm.document_ijazah !== null ?  
                                                                    <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.dataForm.document_ijazah?.documents_path}>
                                                                        Download File Sebelumnya <i className="fa fa-download ms-1"></i>
                                                                    </a>
                                                                : ' '}
                                                            </>
                                                        :
                                                            <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                    }
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">Upload File Akreditasi Program Studi</Label>
                                            <Col md="6">
                                                <FileInput
                                                    name="file_akre"
                                                    col="6"
                                                />
                                                <div className="mt-2">
                                                    {
                                                        this.state.dataForm ?
                                                            <>
                                                                {this.state.dataForm.document_akreditasi !== null ?  
                                                                    <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.dataForm.document_akreditasi?.documents_path}>
                                                                        Download File Sebelumnya <i className="fa fa-download ms-1"></i>
                                                                    </a>
                                                                : ' '}
                                                            </>
                                                        :
                                                            <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                    }
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">Upload File Penyetaraan Ijazah Bagi Lulusan Luar Negeri</Label>
                                            <Col md="6">
                                                <FileInput
                                                    name="file_penyetaraan"
                                                    col="6"
                                                />
                                                <div className="mt-2">
                                                    {
                                                        this.state.dataForm ?
                                                            <>
                                                                {this.state.dataForm.document_penyetaraan !== null ?  
                                                                    <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.dataForm.document_penyetaraan?.documents_path}>
                                                                        Download File Sebelumnya <i className="fa fa-download ms-1"></i>
                                                                    </a>
                                                                : ' '}
                                                            </>
                                                        :
                                                            <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                    }
                                                </div>
                                            </Col>
                                        </Row>

                                        <hr />

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nomor Pertek BKN
                                            </label>
                                            <Col md="3">
                                                 <AvField
                                                    name="education_background_title_sk_number"
                                                    id="education_background_title_sk_number"
                                                    placeholder="Nomor Pertek BKN"
                                                    type="text"
                                                    errorMessage="Masukan Nomor Pertek BKN"
                                                    className="form-control"
                                                    validate={{ required: { value: false } }}
                                                    value={this.state.dataForm.education_background_title_sk_number}
                                                />
                                            </Col>
                                        </Row>  

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Pertek BKN
                                            </label>
                                            <Col md="2">
                                                 <AvField
                                                    name="education_background_title_sk_date"
                                                    id="education_background_title_sk_date"
                                                    placeholder="Tanggal Pertek BKN"
                                                    type="date"
                                                    errorMessage="Masukan Tanggal Pertek BKN"
                                                    className="form-control"
                                                    validate={{ required: { value: false } }}
                                                    value={this.state.dataForm.education_background_title_sk_date}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">Upload File Pertek BKN</Label>
                                            <Col md="6">
                                                <FileInput
                                                    name="file_sk"
                                                    col="6"
                                                />
                                                <div className="mt-2">
                                                    {
                                                        this.state.dataForm ?
                                                            <>
                                                                {this.state.dataForm.document_sk !== null ?  
                                                                    <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.dataForm.document_sk?.documents_path}>
                                                                        Download File Sebelumnya <i className="fa fa-download ms-1"></i>
                                                                    </a>
                                                                : ' '}
                                                            </>
                                                        :
                                                            <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                    }
                                                </div>
                                            </Col>
                                        </Row>       

                                        <hr />                                
                                    
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/pencantuman_gelar.html">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/pencantuman_gelar.html'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView